import { inject } from '@angular/core';
import { CanMatchFn, RedirectCommand, Router } from '@angular/router';
import { AppRouting } from '@core/enums';
import { Store } from '@ngrx/store';
import { userFeature } from '@src/state';
import {  map, take } from 'rxjs';

export const b2bGuard: CanMatchFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(userFeature.selectIsB2B).pipe(
    take(1),
    map((isB2B) => (isB2B ? new RedirectCommand(router.parseUrl(`/${AppRouting.Overview}`)) : true))
  );
};
